import React from 'react'
import { BsSearch } from 'react-icons/bs'
import Slider from 'rc-slider';
import { Link } from 'react-router-dom'
import "./StoreSortOption.css"
import cpu from '../../../assets/images/icon/cpu.png'
import vga from '../../../assets/images/icon/vag.png'
import caseCoputer from '../../../assets/images/icon/computer-tower.png'
import fan from '../../../assets/images/icon/fan-computer.png'
import hdd from '../../../assets/images/icon/hdd.png'
import monitor from '../../../assets/images/icon/monitor.png'
import motherboard from '../../../assets/images/icon/motherboard.png'
import powerSupply from '../../../assets/images/icon/power-supply.png'
import ram from '../../../assets/images/icon/ram.png'
import ssd from '../../../assets/images/icon/ssd.png'
import wifi from '../../../assets/images/icon/wifi-router.png'

function StoreRightFilter() {
    return (
        <>

            <div className="right-filter ">

                <div className="p-3 bg-white fs12 bdrs6 shadowBox mb-3">
                    <li className='nav-item dropdown'>
                        <p className="dropdown-toggle d-flex align-items-center p-0 m-0 py-2  p-2 rounded border" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                            <i className="bi bi-list h5 me-2  d-flex align-items-center"></i>
                            <span>دسته بندی محصولات</span>
                        </p>
                        <ul className="dropdown-menu w-100">
                            <li>
                                <Link className="dropdown-item border-bottom dropitems pb-2 " to='/store'>
                                    <img src={cpu} alt="پردازنده" className='dropSvg img-fluid' />
                                    <span>پردازنده</span>
                                </Link>
                            </li>
                            <li>
                                <Link className="dropdown-item border-bottom dropitems py-2 " to='/store'>
                                    <img src={vga} alt="کارت گرافیک " className='dropSvg img-fluid' />
                                    <span>کارت گرافیک </span>
                                </Link>
                            </li>
                            <li>
                                <Link className="dropdown-item border-bottom dropitems py-2 " to='/store'>
                                    <img src={motherboard} alt=" مادربرد " className='dropSvg img-fluid' />
                                    <span> مادربرد </span>
                                </Link>
                            </li>
                            <li>
                                <Link className="dropdown-item border-bottom dropitems py-2 " to='/store'>
                                    <img src={ram} alt=" رم " className='dropSvg img-fluid' />
                                    <span> رم </span>
                                </Link>
                            </li>
                            <li>
                                <Link className="dropdown-item border-bottom dropitems py-2 " to='/store'>
                                    <img src={powerSupply} alt=" منبع تغذیه  " className='dropSvg img-fluid' />
                                    <span> منبع تغذیه  </span>
                                </Link>
                            </li>
                            <li>
                                <Link className="dropdown-item border-bottom dropitems py-2 " to='/store'>
                                    <img src={monitor} alt=" مانیتور " className='dropSvg img-fluid' />
                                    <span> مانیتور </span>
                                </Link>
                            </li>
                            <li>
                                <Link className="dropdown-item border-bottom dropitems py-2 " to='/store'>
                                    <img src={caseCoputer} alt=" کیس " className='dropSvg img-fluid' />
                                    <span> کیس </span>
                                </Link>
                            </li>
                            <li>
                                <Link className="dropdown-item border-bottom dropitems py-2 " to='/store'>
                                    <img src={hdd} alt=" هارد " className='dropSvg img-fluid' />
                                    <span> هارد </span>
                                </Link>
                            </li>
                            <li>
                                <Link className="dropdown-item border-bottom dropitems py-2 " to='/store'>
                                    <img src={ssd} alt=" اس اس دی " className='dropSvg img-fluid' />
                                    <span> اس اس دی </span>
                                </Link>
                            </li>
                            <li>
                                <Link className="dropdown-item border-bottom dropitems py-2 " to='/store'>
                                    <img src={fan} alt=" خنک کننده  " className='dropSvg img-fluid' />
                                    <span> خنک کننده  </span>
                                </Link>
                            </li>
                            <li>
                                <Link className="dropdown-item  dropitems pt-2" to='/store'>
                                    <img src={wifi} alt=" لوازم جانبی " className='dropSvg img-fluid' />
                                    <span> لوازم جانبی </span>
                                </Link>
                            </li>

                        </ul>
                    </li>
                </div>
                <div className="border p-3 bg-white fs12 bdrs6 shadowBox mb-3">
                    <h6 className='fw-bold fs14 title-dot py-2'>دسته‌بندی‌ها</h6>
                    <p>قطعات اصلی خارج کیس</p>
                    <p> کیس و قطعات اصلی داخل کیس </p>
                    <p> لوازم جانبی کامپیوتر </p>

                </div>
                <div className=" border p-3 bg-white fs12 bdrs6 shadowBox mb-3">
                    <div className="input-group p-0 m-0">
                        <input type="text" className="form-control py-2 fs13" placeholder="جستجو ..." aria-label="جستجو ..." aria-describedby="basic-addon2" />
                        <span className="input-group-text " id="basic-addon2">
                            <BsSearch className='fs-6' />
                        </span>
                    </div>
                </div>
                <div className=" border p-3 bg-white fs12 bdrs6 shadowBox mb-3">
                    <h6 className='fw-bold fs14 title-dot py-2'> محدوده قیمت </h6>

                    <Slider
                        range
                        min={-10}
                        max={100}
                        marks={null}
                        step={10}
                        // onChange={log}
                        defaultValue={[-8, 98]}
                        allowCross={false}
                        pushable
                    // draggableTrack
                    // trackStyle={[{background:'red',height:'10px'}]}
                    // railStyle={{height:'10px',width:'100px'}}
                    />

                </div>
                <div className=" border p-3 bg-white fs12 bdrs6 shadowBox mb-3">
                    <h6 className='fw-bold fs14 title-dot py-2'> برندها  </h6>

                    <label className="custom-checkbox ">
                        <input type="checkbox" className="brandFilter" checked value="24643" name="brand/24643" data-id="24643" data-title="سامسونگ" />
                        <span>سامسونگ</span>
                    </label>
                    <label className="custom-checkbox ">
                        <input type="checkbox" className="brandFilter" value="24643" name="brand/24643" data-id="24643" data-title="ایسوس" />
                        <span>ایسوس</span>
                    </label>
                    <label className="custom-checkbox ">
                        <input type="checkbox" className="brandFilter" value="24643" name="brand/24643" data-id="24643" data-title="گیگابایت" />
                        <span>گیگابایت</span>
                    </label>
                    <label className="custom-checkbox ">
                        <input type="checkbox" className="brandFilter" value="24643" name="brand/24643" data-id="24643" data-title="کولرمستر" />
                        <span>کولرمستر</span>
                    </label>
                    <label className="custom-checkbox ">
                        <input type="checkbox" className="brandFilter" value="24643" name="brand/24643" data-id="24643" data-title="کروشیال" />
                        <span>کروشیال</span>
                    </label>
                    <label className="custom-checkbox ">
                        <input type="checkbox" className="brandFilter" value="24643" name="brand/24643" data-id="24643" data-title="اینتل" />
                        <span>اینتل</span>
                    </label>
                </div>
            </div>
        </>
    )
}

export default StoreRightFilter
